<template>
  <div class="page-header pb-container">
    <div class='size1-text pri-color'>Current Billing Cycle {{ fmtCycleDate }}</div>
    <div class="ipb-container">
      <div class="columns">
          <div class="column header-labels">
            <div class="page-heading-label">Total Current</div>
            <div class="page-heading-label">Total Past Due</div>
            <div class="page-heading-label">Grand Total</div>
          </div>
          <div class="column">
            <div class="page-heading-total-amount app-green">
              {{ totalCurrentAmtDueFormatted }}
            </div>
            <div class="page-heading-total-amount app-red">{{totalPastAmtDueFormatted}}</div>
            <div class="page-heading-total-amount app-green">{{totalGrandAmtDueFormatted}}</div>
          </div>
          <div class="column">
            <a v-if="!billRunPaused" v-on:click="toggleBilRunStatus()"
              class="button is-primary pause-btn-toggle">
              Pause Bill Run
            </a>
            <a v-if="billRunPaused" v-on:click="toggleBilRunStatus()"
              class="button is-danger pause-btn-toggle">
              Resume Bill Run
            </a>
          </div>
      </div>

    </div>
  </div>

  <div class="level">
    <div class="level-left">
      <div class="page-heading-label level-item">
          Per Page:
      </div>
      <div class="level-item">
        <select v-on:change="onPageSizeChanged()" id="page-size">
            <option value="10" selected="">10</option>
            <option value="25">25</option>
            <option value="50">50</option>
            <option value="200">200</option>
        </select>
      </div>
    </div>
    <div class="level-right">
      <div class="level-item">
        <button id="export-button" v-on:click="onBtExport()" class="button is-secondary">
          Export to CSV
        </button>
      </div>
    </div>
  </div>
  <ag-grid-vue
      style="width: 100%; height: 600px;"
      class="ag-theme-alpine"
      id="myGrid"
      :gridOptions="gridOptions"
      @grid-ready="onGridReady"
      :columnDefs="columnDefs"
      :pagination="true"
      :paginationPageSize="paginationPageSize"
      :defaultColDef="defaultColDef"
      :modules="modules"
      :rowData="rowData">
  </ag-grid-vue>
  <div id='injectable-tag-wrapper' style="display:none;"></div>
  <PageLoading :showLoading="!isReady"></PageLoading>
</template>

<script>
import { AgGridVue } from 'ag-grid-vue3';
import { AllCommunityModules } from 'ag-grid-community';
import MoneyUtils from '@/shared/money-utils';
import GridUtils from '@/shared/grid-utils';
import PageLoading from '@/components/page-loading.vue';

// import { format } from 'date-fns';

window.currencyFormatter = function currencyFormatter(params) {
  const formatter = new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
  });

  return formatter.format(params.value);
};

export default {
  name: 'CurrentBilling',
  components: { AgGridVue, PageLoading },
  data() {
    return {
      billRunPaused: false,
      gridOptions: null,
      gridApi: null,
      columnApi: null,
      columnDefs: null,
      defaultColDef: null,
      modules: AllCommunityModules,
      rowData: null,
      paginationPageSize: null,
      totalCurrentAmtDue: 0,
      totalPastAmtDue: 0,
      grandTotalAmtDue: 0,
      cycleDate: '',
      billFromDate: '',
      isReady: false,
    };
  },
  mixins: [MoneyUtils, GridUtils],
  methods: {
    async fetchGridData() {
      this.isReady = false;
      await this.$store.dispatch('billCycles/fetchCurrentBillCycle');
      this.rowData = this.$store.state.billCycles.currentBillCycle.data;
      this.billRunPaused = this.$store.state.billCycles.currentBillCycle.isPaused > 0;
      this.computeTotalsDue();
      this.isReady = true;
    },
    computeTotalsDue() {
      if (!this.rowData || this.rowData.length === 0) {
        this.rowData = [];
      } else {
        this.rowData.forEach((row) => {
          this.totalCurrentAmtDue += row.TotalAmountDue;
          this.totalPastAmtDue += row.PastDueTotal;
          this.grandTotalAmtDue += row.GrandTotalDue;
        });
        this.cycleDate = this.rowData[0].BillCycle;
        this.billFromDate = this.rowData[0].BillFrom;
      }
    },
    async onGridReady() {
      // eslint-disable-next-line no-console
      await this.fetchGridData();
    },
    onBtExport() {
      const expParams = {
        columnKeys: ['BusinessName', 'ContactName', 'TotalTR', 'VinCorTR', 'BillableTR', 'UnitCost', 'TotalAmountDue', 'PastDueTotal', 'AdjustmentAmount', 'GrandTotalDue'],
      };

      this.gridApi.exportDataAsCsv(expParams);
      // unfortunately, you need a commercial license of ag grid for this one.
      //      this.gridApi.exportDataAsExcel();
    },
    async toggleBilRunStatus() {
      this.billRunPaused = !this.billRunPaused;
      const payload = {
        billFrom: this.billFromDate,
        billTo: this.cycleDate,
        isPaused: this.billRunPaused ? 1 : 0,
      };
      await this.$store.dispatch('billCycles/updateCycleStatus', payload);
    },
    onPageSizeChanged() {
      const ps = document.getElementById('page-size').value;
      this.gridApi.paginationSetPageSize(Number(ps));
    },
    buildArrayRowForCSV(rawData) {
      console.log('inside build array row for CSV');
      const res = [];
      res.push(rawData.UserId);
      res.push(rawData.BusinessName);
      res.push(rawData.Contact);
      res.push(`"=""${rawData.EIN}"""`);
      res.push(rawData.Email);
      res.push(`"=""${rawData.SubmissionId}"""`);
      res.push(`"=""${rawData.ReturnId}"""`);
      res.push(rawData.CorrectedVIN);
      res.push(rawData.UnitCost);
      res.push(rawData.FilingDate);
      // const fd = new Date(rawData.FilingDate);
      // res.push(format(fd, 'MM/dd/yy HH:mm:ss'));

      return res;
    },
  },
  beforeMount() {
    this.gridOptions = {};
    this.columnDefs = [
      {
        field: 'BusinessName',
        minWidth: 200,
        editable: true,
      },
      {
        field: 'ContactName',
        headerName: 'Contact',
        editable: true,
      },
      {
        field: 'TotalTR',
        headerName: 'Tot Ret',
        filter: 'agNumberColumnFilter',
        filterParams: GridUtils.numberFilterParams,
        editable: true,
      },
      {
        field: 'VinCorTR',
        headerName: 'VIN Cor TR',
        filter: 'agNumberColumnFilter',
        filterParams: GridUtils.numberFilterParams,
        editable: true,
      },
      {
        field: 'BillableTR',
        filter: 'agNumberColumnFilter',
        filterParams: GridUtils.numberFilterParams,
        editable: true,
      },
      {
        field: 'UnitCost',
        filter: 'agNumberColumnFilter',
        filterParams: GridUtils.numberFilterParams,
        editable: true,
        // eslint-disable-next-line no-undef
        valueFormatter: currencyFormatter,
      },
      {
        field: 'TotalAmountDue',
        headerName: 'Current Due',
        filter: 'agNumberColumnFilter',
        filterParams: GridUtils.numberFilterParams,
        editable: true,
        // eslint-disable-next-line no-undef
        valueFormatter: currencyFormatter,
        minWidth: 128,
      },
      {
        field: 'PastDueTotal',
        headerName: 'Past Due',
        filter: 'agNumberColumnFilter',
        filterParams: GridUtils.numberFilterParams,
        editable: true,
        // eslint-disable-next-line no-undef
        valueFormatter: currencyFormatter,
      },
      {
        field: 'AdjustmentAmount',
        headerName: 'Adj Amt',
        filter: 'agNumberColumnFilter',
        filterParams: GridUtils.numberFilterParams,
        editable: true,
        // eslint-disable-next-line no-undef
        valueFormatter: currencyFormatter,
      },
      {
        field: 'GrandTotalDue',
        headerName: 'Grand Total',
        editable: true,
        filter: 'agNumberColumnFilter',
        filterParams: GridUtils.numberFilterParams,
        // eslint-disable-next-line no-undef
        valueFormatter: currencyFormatter,
      },
      {
        field: 'UserID',
        headerName: '',
        sortable: false,
        filter: false,
        minWidth: 180,
        cellRenderer: (params) => {
          const wrap = document.createElement('div');

          const sep = document.createElement('span');
          sep.innerText = ' | ';

          const route = {
            name: 'customer-detail',
            params: { id: params.value },
          };
          const detailsLink = document.createElement('a');
          detailsLink.href = this.$router.resolve(route).href;
          detailsLink.innerText = 'View Details';
          detailsLink.addEventListener('click', (e) => {
            e.preventDefault();
            this.$router.push(route);
          });

          const exportLink = document.createElement('a');
          exportLink.href = '#';
          // console.log('Params are: ');
          // console.log(params.data.status);
          exportLink.innerText = 'Export';
          exportLink.addEventListener('click', async (e) => {
            e.preventDefault();
            await this.$store.dispatch('billCycles/fetchCurrentBillCycleReturns', { userId: params.data.UserID });
            const rows = this.$store.state.billCycles.currentBillCycleReturns;
            const formattedRows = rows.map((el) => this.buildArrayRowForCSV(el));
            const headerRow = ['UserId', 'BusinessName', 'Contact', 'EIN', 'Email', 'SubmissionId', 'ReturnId', 'CorrectedVIN', 'UnitCost', 'FilingDate'];
            formattedRows.unshift(headerRow);

            const csvContent = `data:text/csv;charset=utf-8,${formattedRows.map((el) => el.join(',')).join('\n')}`;
            const fileName = `CurrentBillingReturnData-${params.data.UserID}.csv`;

            const encodedUri = encodeURI(csvContent);
            const tempExportLink = document.createElement('a');
            tempExportLink.setAttribute('href', encodedUri);
            tempExportLink.setAttribute('download', fileName);
            const linkWrap = document.getElementById('injectable-tag-wrapper');
            linkWrap.innerHTML = tempExportLink; // Required for FF
            tempExportLink.click(); // This will download the data file
          });
          wrap.appendChild(exportLink);
          wrap.appendChild(sep);
          wrap.appendChild(detailsLink);
          return wrap;
        },
      },
    ];
    this.defaultColDef = {
      editable: false,
      sortable: true,
      flex: 1,
      minWidth: 50,
      filter: 'agTextColumnFilter',
      filterParams: GridUtils.textFilterParams,
      resizable: true,
    };
    this.paginationPageSize = 10;
  },
  mounted() {
    this.gridApi = this.gridOptions.api;
    this.gridColumnApi = this.gridOptions.columnApi;
  },
  computed: {
    visibleProducts() {
      return this.$store.getters.filteredProducts;
    },
    fmtCycleDate() {
      // We only check for 8 since the db query leaves off leading
      // zeros for day and month when it's a single digit value.
      // 2021-9-7 vs 2021-09-07
      if (!this.cycleDate || this.cycleDate.length < 8) {
        return '';
      }
      const dateParts = this.cycleDate.split('-');
      if (!dateParts || dateParts.length !== 3) {
        return '';
      }
      // const yy = dateParts[0].substring(2);
      return `(${dateParts[1]}/${dateParts[2]}/${dateParts[0]})`;
    },
    totalCurrentAmtDueFormatted() {
      return this.formatAsMoney(this.totalCurrentAmtDue);
    },
    totalPastAmtDueFormatted() {
      return this.formatAsMoney(this.totalPastAmtDue);
    },
    totalGrandAmtDueFormatted() {
      return this.formatAsMoney(this.grandTotalAmtDue);
    },
  },
  props: {
    msg: String,
  },
};

</script>
<style src='ag-grid-community/dist/styles/ag-theme-alpine.css'></style>
<style src='ag-grid-community/dist/styles/ag-grid.css'></style>
<style lang="scss" scoped>
    #export-button {
        font-weight: bold;
    }

@import "~ag-grid-community/src/styles/ag-grid.scss";
@import "~ag-grid-community/src/styles/ag-theme-alpine/sass/ag-theme-alpine-mixin";
.ag-theme-alpine {
    @include ag-theme-alpine((
        // use theme parameters where possible
        header-foreground-color: #FFF,
        header-background-color: #0F3D80,
        font-family: ('Helvetica', 'Arial', 'sans-serif'),
    ));

    .ag-icon {
      color: #FFF;
    }
    .ag-paging-button > .ag-icon {
        color: #000;
    }
    .ag-header-cell-text {
      font-size: 14px;
    }
}
.ag-font-style {
  user-select: initial;
  -moz-user-select: text;
  -ms-user-select: text;
  -webkit-user-select: text;
}
  .pb-container {
    display: flex;
    justify-content: space-between;
  }
  .ipb-container {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
  .tb {
    padding-left: 10px;
  }
  .tr {
    padding-left: 20px;
  }
  .pause-btn-toggle {
    min-width: 153px;
  }

</style>
